

































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { Locales } from "@/i18n/locales";

@Component({
  components: {},
})
export default class DatatableComponent extends Vue {
  records: any = [];
  loading: boolean = false;
  options: any = {};
  saveList: any = [];
  search: string = "";

  filters: any = {
    search: "",
    Language: "en-US",
  };

  languages: any = [
    { value: "en-US", text: "English" },
    { value: "fr-FR", text: "French" },
  ];

  selected: string = localStorage.getItem("language") || Locales.EN;

  snackbar: boolean = false;
  message: string = "";
  snackBarColor: string = "red";

  headers: Array<object> = [];

customFilter(items, filters, filter, headers) {
    // Init the filter class.
    // @ts-ignore
    const cf = new this.$MultiFilters(items, filters, filter, headers);

    cf.registerFilter("search", function (searchWord, items) {
      if (searchWord.trim() === "") return items;

      return items.filter((item) => {
        return item.Key.toLowerCase().includes(searchWord.toLowerCase());
      }, searchWord);
    });

    cf.registerFilter("Language", function (language, items) {
      if (language.trim() === "") return items;

      return items.filter((item) => {
        return item.Language.toLowerCase() === language.toLowerCase();
      }, language);
    });

    // Its time to run all created filters.
    // Will be executed in the order thay were defined.
    return cf.runFilters();
  }

  // Handler when user input something at the "Filter" text field.
  filterByKey(val) {
    // @ts-ignore
    this.filters = this.$MultiFilters.updateFilters(this.filters, {
      search: val,
    });

    this.readDataFromAPI(this.filters.Language, this.filters.search);
  }

  // Handler when user  select some author at the "Author" select.
  filterLanguage(val) {
    // @ts-ignore
    this.filters = this.$MultiFilters.updateFilters(this.filters, {
      Language: val,
    });

    this.readDataFromAPI(this.filters.Language, this.filters.search);
  }

  //this will trigger in the onReady State
  mounted() {
    this.headers = [
      { text: this.$t("Key"), value: "Key" },
      { text: this.$t("Value"), value: "Value" },
      { text: "", value: "" },
    ];
    this.readDataFromAPI(this.selected);
  }

  //Reading data from API method.
  readDataFromAPI(lang, key = "") {
    this.loading = true;
    const { page, itemsPerPage } = this.options;
    let pageNumber = page - 1;

    this.$services.languageManager.readAllDataFromAPI(lang).then((resp) => {
      this.loading = false;
      let data: any = resp.Record;

      if (key) {
        data = resp.Record.filter((x) =>
          x.Key.toLowerCase().includes(key.toLowerCase())
        );
      }

      this.records = data;
    });
  }

  onUpdate(item) {
    this.saveList.push(item);
    var self = this;

    this.$services.languageManager
      .saveData(this.filters.Language, item)
      .then((resp) => {
        self.snackbar = true;
        self.snackBarColor = "green";
        self.message = "Updated successfully.";
      });
  }

  onBulkSave() {
    // this.$services.languageManager
    //   .saveBulkData(this.saveList)
    //   .then((resp) => {});
  }
}
